import { Component, Input, TemplateRef } from '@angular/core';
import { DurationPipe } from '../../pipes/duration.pipe';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-template-link-copy-wrapper',
  template: `
    <div class="wrapper">
      <a *ngIf="isStatic; else dynamicContent" [href]="href" class="main-content" [class.main-link]="href">
        <ng-content></ng-content>
      </a>
      <ng-template #dynamicContent>
        <a *ngIf="href; else noHref" [href]="href" class="main-content" [class.main-link]="href">
          <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="context"></ng-container>
        </a>
        <ng-template #noHref>
          <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="context"></ng-container>
        </ng-template>
      </ng-template>

      <button *ngIf="_copyText" (click)="copyContent($event)" class="copy-button" title="Copy value">
        <i #copyIcon class="fa fa-clipboard"></i>
      </button>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        position: relative;
        width: 100%;
        height: 100%;
      }
      .wrapper {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
      }
      .main-link {
        display: block;
        flex-grow: 1;
        text-decoration: none;
        color: inherit;
        cursor: pointer;
        padding: 5px;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .copy-button {
        position: absolute;
        top: 4px;
        right: 4px;
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 0;
        color: #aaa;
        visibility: hidden;
        z-index: 2;
      }
      :host(:hover) .copy-button {
        visibility: visible;
      }
      .copy-button:hover i {
        color: #000;
      }
      .copied-feedback {
        color: #28a745 !important;
      }
    `,
  ],
  providers: [DatePipe],
})
export class TemplateLinkWrapperComponent {
  private durationPipe = new DurationPipe();
  public _copyText: string;
  @Input() isStatic = false;
  @Input() href: string | null = null;
  @Input() template?: TemplateRef<any>;
  @Input() context?: any;

  @Input() set copyText(value: any) {
    if (value !== null && value !== undefined) {
      this._copyText = String(value);
    } else {
      this._copyText = null;
    }
  }

  constructor(private datePipe: DatePipe) {}

  copyContent(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    const textToCopy = String(this._copyText);
    if (!textToCopy) {
      return;
    }

    const textArea = document.createElement('textarea');
    const textView = this.viewConverter(textToCopy);
    textArea.value = textView;
    textArea.style.position = 'fixed';
    textArea.style.top = '-9999px';
    textArea.style.left = '-9999px';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        const icon = (event.currentTarget as HTMLElement).querySelector('i');
        if (icon) {
          const originalClass = icon.className;
          icon.className = 'fa fa-check copied-feedback';
          setTimeout(() => {
            icon.className = originalClass;
          }, 1500);
        }
      }
    } catch (err) {
      console.error('Copy function is failed ', err);
    }

    document.body.removeChild(textArea);
  }

  private viewConverter(textToCopy: string) {
    switch (this.context.field.fieldName) {
      case 'QueueTime':
      case 'CallDuration':
      case 'Wrapup':
      case 'TotalTime':
      case 'VBEventDur':
        return this.durationPipe.transform(textToCopy, 'HH:mm');
      case 'IsCallClosedByAgent':
      case 'IsTransferred':
      case 'Vend':
        return textToCopy === 'true' ? 'Yes' : 'No';
      case 'CallTime':
        return this.datePipe.transform(textToCopy, 'MMM d, yyyy hh:mm:ss a');
      default:
        return textToCopy;
    }
  }
}
